import LightningFS from "@isomorphic-git/lightning-fs"
import {IPFS} from "ipfs-core"
import OrbitDB from "orbit-db"
import {createContext, Dispatch, SetStateAction} from "react"

interface ServerMetadata {
  isGitSupported: boolean
}

interface BackendContextInterface {
  // Storage
  ipfs?: IPFS
  orbit?: OrbitDB
  fs?: LightningFS

  // Git Control Server
  metadata?: ServerMetadata,
  setIsGitSupported?: Dispatch<SetStateAction<boolean>>
}

export const BackendContext = createContext<BackendContextInterface>({})
